import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Icon_Mail",
  "use": "Icon_Mail-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"Icon_Mail\">\r\n<path d=\"M18,2H2C0.896,2,0,2.896,0,4v12c0,1.104,0.896,2,2,2h16c1.104,0,2-0.896,2-2V4C20,2.896,19.104,2,18,2z M10.001,11.081\r\n\tL2.22,3.3H17.78L10.001,11.081z M7.08,10L1.3,15.781V4.219L7.08,10z M8,10.92l1.541,1.54c0.122,0.122,0.288,0.19,0.46,0.19\r\n\tc0.173,0,0.338-0.068,0.46-0.19L12,10.92l5.78,5.781H2.22L8,10.92z M12.92,10l5.78-5.781v11.562L12.92,10z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Icon_Mail.svg
// module id = 757
// module chunks = 0